<template>

<div id="quiz-page">
  
    <div id="progress-container">
      <div v-for="index in totalQuestions" :key="index" 
           class="progress-step" 
           :class="{ 'correct': index <= correctAnswersCount }"></div>
    </div>

      <div id="congratulations-panel" v-show="showCongratulations">
        <div id="congratulations-message">You are starting to become aware about Sea Turtles, keep going!</div>
        <button id="facebook-share-button">Facebook</button>
        <button id="twitter-share-button">Twitter</button>
        <button id="copy-link-button">Link</button>
        <button id="home-button" v-if="showGoHomeButton" @click="goHome">Continue</button>
      </div>

      <div id="quiz-container" v-if="!showCongratulations">
        <div id="question-container" v-if="!displayFactNext">
          <h2>{{ currentQuestion.question }}</h2>
          <div id="answer-buttons" class="btn-grid">
  
  <button v-for="(answer, index) in currentQuestion.answers"
        :key="index"
        @click="checkAnswer(answer.text)"
        :class="{ 'selected': selectedAnswer === answer }"
        :disabled="isAnswerChecked">
    <img :src="answer.icon" alt="Icon" class="answer-icon"> <!-- Display the SVG icon -->
    {{ answer.text }} <!-- Display the answer text -->
</button>
          </div>
        </div>
        <div id="fact-display" v-show="displayFactNext">
          <p>{{ currentQuestion.fact }}</p>
        </div>
      </div>
<div id="action">
      <div id="status-panel" v-show="showStatus">
        <p id="status-message" :class="{ 'correct': isCorrect, 'wrong': !isCorrect }" v-html="statusMessage">
        </p>
        </div>
        <button  v-if="!isAnswerChecked" @click="checkAnswer" 
        :disabled="!selectedAnswer || isAnswerChecked"> Continue </button>

      <!-- <button v-if="!isAnswerChecked && selectedAnswer" 
              @click="checkAnswer" 
              :disabled="!selectedAnswer">Check Answer</button> -->
      <button   v-if="isCorrect && isAnswerChecked && !displayFactNext" 
              @click="showFact"
              :style="{ backgroundColor: 'green' }">Continue</button>
      <!-- Ensure "Next Question" button appears correctly for both correct and incorrect answers -->
      <button v-if="isAnswerChecked && (displayFactNext || !isCorrect)"
              @click="setNextQuestion"
              :style="{ backgroundColor: !isCorrect ? 'red' : 'green' }">Continue</button>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      isQuizStarted: true,
      showCongratulations: false,
      showGoHomeButton: false,  // New property to control the visibility of the Go Home button
      currentQuestionIndex: 0, 
      correctAnswersCount: 0,
      totalQuestions: 10,
      questions: [
        {
          question: "Which plastic item, known for endangering sea turtles, has widespread awareness?",
          answers: [{ text: "Plastic Bottle", icon: "Water Bottle.svg" },
                    { text: "Plastic Straw", icon: "Plastic Straw.svg" },
                    { text: "Plastic Bag", icon: "bag.svg" },
                    { text: "Fishing Gear", icon: "Fishin Gear.svg" }],
          correct: "Plastic Straw",
          fact: "Dr. Christine Figgener’s impactful 2015 video, where she documented the removal of a plastic straw from a sea turtle’s nostril. Her video make the new perspective about plastic wastes"
        },
        {
          question: "Which type of plastic is most commonly lead the deaths of sea turtles?", 
          answers:  [{ text: "Plastic Bottle", icon: "Water Bottle.svg" },
                    { text: "Plastic Straw", icon: "Plastic Straw.svg" },
                    { text: "Plastic Bag", icon: "bag.svg" },
                    { text: "Fishing Gear", icon: "Fishin Gear.svg" }],
          correct: "Plastic Bag",
          fact: "Plastic bags are often mistaken for food by sea turtles, as they resemble jellyfish, a common prey item for turtles. This misconception can lead to ingestion and serious health issues, including blockages in their digestive systems."
        }, 
        { question: "Which sea turtle species is commonly found nesting in Thailand?", 
        answers: [{ text: "Leatherback Turtle", icon: "Leatherback.svg" },
                  { text: "Loggerhead Turtle", icon: "Loggerhead Turtle.svg" },
                  { text: "Green Turtle", icon: "Green Turtle.svg" },
                  { text: "Hawksbill Turtle", icon: "Hawksbill Turtle.svg" }],
        correct: "Green Turtle",
        fact:"From the seven species of sea turtles found worldwide, five species can be found in Thai waters: the Leatherback turtle, Green turtle, Hawksbill turtle, Olive ridley turtle, and Loggerhead turtle. However, only the Leatherback turtle, Green turtle, Hawksbill turtle, and Olive ridley turtle lay eggs on Thai beaches." },
        { question: "When is the sea turtle nesting season in Thailand?", 
        answers:  [{ text: "Summer", icon: "Summer.svg" },
                  { text: "Spring", icon: "Spring.svg" },
                  { text: "Fall", icon: "Autumn.svg" },
                  { text: "Winter", icon: "Winter.svg" }],
        correct: "Summer",
        fact:"Sea turtle nesting season in Thailand occurs during the summer months, typically from March to September. During this period, female sea turtles return to the beaches where they were born to lay their eggs. The warm temperatures and calm waters make it an ideal time for nesting, ensuring the survival of the eggs and hatchlings. This nesting season is vital for the conservation of sea turtles, as it marks the beginning of their life cycle and contributes to the preservation of these endangered species." },
        { question: "What should you do if you find a sea turtle nesting on a beach?", 
        answers: [{ text: "Walk away", icon: "Walk Away.svg" },
                  { text: "Take photo", icon: "Take picture.svg" },
                  { text: "Help them", icon: "Help them.svg" },
                  { text: "Don’t disturb", icon: "DND.svg" }],
        correct: "Don’t disturb",fact:"If you come across a sea turtle nesting on a beach in Thailand, it's crucial to avoid disturbing them for several reasons. Firstly, disturbing nesting turtles can cause them to abandon their nesting attempts, which can significantly impact their reproductive success and the survival of future generations. Secondly, sea turtles are already facing numerous threats, including habitat loss, pollution, and poaching, so minimizing disturbances during the nesting process is essential for their conservation. Additionally, disturbing nesting turtles can increase their stress levels, which may affect their health and well-being. Therefore, it's vital to respect these magnificent creatures and allow them to complete their nesting cycle undisturbed." },
        { question: "How can tourists contribute to the protection of sea turtles?", 
        answers: [{ text: "Eating local seafood", icon: "Localseafood.svg" },
                  { text: "Cleaning up beaches", icon: "Cleaning.svg" },
                  { text: "Water sports", icon: "Water Sport.svg" },
                  { text: "Promoting on social media", icon: "Social Media.svg" }], 
        correct: "Cleaning up beaches",
        fact:"Tourists can contribute to the protection of sea turtles by cleaning up beaches. Removing litter and debris helps create a safer environment for nesting females and hatchlings, reducing the risk of entanglement and ingestion of harmful materials. Additionally, cleaner beaches provide better nesting conditions and contribute to the overall health of marine ecosystems." },
        { question: "What artificial factor can disrupt sea turtle hatchlings in Thailand?", 
        answers: [{ text: "Sunlight", icon: "Summer.svg" },
                  { text: "Bright lights", icon: "Bright Light.svg" },
                  { text: "Rain", icon: "Rain.svg" },
                  { text: "Wind", icon: "Wind.svg" }], 
        correct: "Bright lights",
        fact:"Artificial lights, such as those from beachfront properties or streetlights, can disorient sea turtle hatchlings. Instead of navigating toward the ocean, they may be attracted inland, leading them away from their natural habitat and increasing their vulnerability to predators, exhaustion, and dehydration. Therefore, minimizing artificial light pollution is crucial to support the successful journey of sea turtle hatchlings from nest to sea." },
        { question: "What is a sign that indicates a beach in Thailand is a protected sea turtle nesting area?", 
        answers: [{ text: "Flags", icon: "Flag.svg" },
                  { text: "Signboards", icon: "Sign.svg" },
                  { text: "Tents", icon: "Tent.svg" },
                  { text: "Anchors", icon: "Anchors.svg" }],  
        correct: "Signboards",
        fact:"Signboards are a key indicator that a beach in Thailand is a protected sea turtle nesting area. These signboards typically provide important information about the nesting season, conservation efforts, and guidelines for visitors to follow to ensure the safety of sea turtles and their hatchlings. They serve as a visual cue for beachgoers to be mindful of their activities and to respect the natural habitat of these endangered species." },
        { question: "Which of these initiatives helps protect sea turtle nests?", 
        answers:  [{ text: "Construction", icon: "Construction.svg" },
                  { text: "Reforestation", icon: "Deforestation.svg" },
                  { text: "Beach patrols", icon: "Beach Patrol.svg" },
                  { text: "Shopping centers", icon: "Shopping Mall.svg" }], 
        correct: "Beach patrols",
        fact:"Beach patrols are instrumental in protecting sea turtle nests. These initiatives involve monitoring nesting beaches regularly to prevent poaching, predation, and disturbances to nesting females and their eggs. By patrolling the beaches, trained personnel can deter illegal activities, educate visitors about the importance of conservation, and ensure that sea turtles have a safe environment for nesting and hatching." },
        { question: "What is a natural predator of sea turtle nests in Thailand?", 
        answers: [{ text: "Bird", icon: "Bird.svg" },
                  { text: "Fish", icon: "Fish.svg" },
                  { text: "Human", icon: "Human.svg" },
                  { text: "Snake", icon: "Snake.svg" }],
        correct: "Snake",
        fact:"One of the natural predators of sea turtle nests in Thailand is the snake. These reptiles are known to prey on sea turtle eggs when they are laid in the sand. Snakes pose a significant threat to the survival of sea turtle hatchlings, as they can easily locate and consume the eggs buried in the beach nests." },
      ],
      shuffledQuestions: [],
      questionsToReanswer: [],
      currentQuestion: {},
      selectedAnswer: null,
      displayFactNext: false,
      showStatus: false,
      statusMessage: '',
      isNextButtonVisible: false,
      isCorrect: false,
      nextButtonBackgroundColor: ''
    };
  },
  methods: {
    createProgressBar(totalQuestions) {
      this.progressBarWidth = ((this.currentQuestionIndex + 1) / totalQuestions) * 100;
    },
    startQuiz() {
      this.shuffledQuestions = [...this.questions];
      this.currentQuestionIndex = 0;
      this.correctAnswersCount = 0;
      this.questionsToReanswer = [];
      this.createProgressBar(this.shuffledQuestions.length);
      this.setNextQuestion();
      this.showGoHomeButton = false;  // Ensure Go Home button is hidden at the start
    },
 
    checkAnswer(selectedAnswerText) {
  // Find the selected answer object based on its text
  const selectedAnswer = this.currentQuestion.answers.find(answer => answer.text === selectedAnswerText);

  this.isCorrect = selectedAnswer.text === this.currentQuestion.correct;
  if (this.isCorrect) {
    this.statusMessage = "Correct!";
    this.correctAnswersCount++;
    this.updateProgress(); // Update progress only when the answer is correct
  } else {
    // Format the message to display "Wrong!" followed by the correct answer in a clear format
    this.statusMessage = `Wrong! <br>The correct answer is: '${this.currentQuestion.correct}'.`;
    this.questionsToReanswer.push(this.currentQuestion);
    this.displayFactNext = false; // No fact display for incorrect answers
  }
  this.showStatus = true;
  this.isAnswerChecked = true;
},


updateProgress() {
  this.progressBarWidth = (this.correctAnswersCount / this.totalQuestions) * 100;
  },
  setNextQuestion() {
    this.displayFactNext = false; // Ensure fact display is reset
    if (this.currentQuestionIndex < this.shuffledQuestions.length) {
      this.currentQuestion = this.shuffledQuestions[this.currentQuestionIndex++];
      this.resetState();
    } else if (this.questionsToReanswer.length > 0) {
      this.shuffledQuestions = this.questionsToReanswer.slice();
      this.questionsToReanswer = [];
      this.currentQuestionIndex = 0;
      this.currentQuestion = this.shuffledQuestions[this.currentQuestionIndex++];
      this.resetState();
    } else {
      this.finishQuiz();
    }
  },

selectAnswer(answerText) {
  this.selectedAnswer = answerText;   
 },

    showFact() {
      this.isNextButtonDisabled = false;
      this.displayFactNext = true;
      this.showStatus = false;
    },
    goHome() {
      this.$router.push('/');
    },
    resetState() {
    this.selectedAnswer = null;
    this.isNextButtonVisible = true;
    this.showStatus = false;
    this.displayFactNext = false;
    this.isAnswerChecked = false;
  },
    finishQuiz() {
  this.createProgressBar =false
  // Set the state to show the congratulations panel
  this.showCongratulations = true;

  // Ensure no buttons for showing fact or moving to the next question are visible
  this.displayFactNext = false;
  this.isAnswerChecked = false;  // Ensures no check related buttons are visible
  this.showGoHomeButton = true;  // Only the Go Home button should be visible on the final screen

  // Reset other UI elements as necessary
  this.showStatus = false;
  this.selectedAnswer = null;
},

  },
  mounted() {
    this.startQuiz();
  }
};
</script>


<style>
body{
    font-family: Futura, serif; /* กำหนดแบบอักษร Futura เป็นแบบอักษรหลัก หรือใช้แบบอักษรใดก็ได้ที่คุณต้องการ */
    justify-content: center;
    align-items: center;
    margin: 0; 
    background-repeat: no-repeat;
    background-size: cover;
    background-repeat: no-repeat;
    background-size: cover;
} 

#quiz-page {
    width: 1200px;
    height: 720px;
    display: flex; 
flex-direction: column;    
justify-content: center;
    align-items: center;
    gap: 40px;
    background-size: cover;
    transition: background-position 0.5s ease-out; /* Animate background position changes */
}

/* #body-quiz{
  height: 60px;
  width: 1000px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    display: flex; 
} */

#question-container{
  display: flex;
    justify-content: center;
    flex-direction: column;
}
h2{
  align-items: center;
}

#answer-buttons {
font-family: Futura, serif;
display: flex;
flex-direction: row;
margin: 5px;
padding: 10px 20px;
justify-content: center; /* Centers the buttons horizontally, remove if not needed */
align-items: center; 
cursor: pointer;
align-items: center;
}

.hide {
    display: none;
}

#progress-container {
  display: flex;
    align-items: center;
    justify-content: center; 
    width: 100%;
    margin: 20px; 
}

.progress-step {
  width: 80px; /* Width of each step */
    height: 10px; /* Height of each step */
    background-color: #ddd; /* Default background color */
    border-radius: 10px; /* Makes it circular */
    margin-right: 8px;
}

.progress-step.active {
  background-color: #aaa; /* Active step color */
}

.progress-step.correct {
  background-color: #4CAF50; /* Correct answer color */
}

button{
  font-family: Futura, serif ;
  font-size: 16px;
  width: 120px;
  height: 40px;
  border-radius: 20px;
  z-index: 10;
  align-items: center;
  justify-content: center;
  position: relative;
}

.button-correct {
  color: white;
  background-color: #4CAF50;
}

.button-incorrect {
  background-color: red;
}
/* Add this to your component or global stylesheet */
#status-panel {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
}

#congratulations-panel {
    text-align: center;
    margin-top: 150px;
  }
  
#congratulations-message {
    font-size: 24px;
}

#fact-display{ 
  font-size: 16px;
    width: 640px;
    height: 300px;
    text-align: center;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.5);
}

#status-message {
    width: 1000px;
    height: 120px;
    position: absolute;
    display: flex;
padding-top: 20px;    
align-items: top;
    justify-content: center;
    border-radius: 20px 20px 0px 0px;
    z-index: -100;
}
.correct{
    background-color: #3DD467; 
    color: white;
}

.wrong {
    background-color: #FF6961; 
    color: white;
}

#facebook-share-button {
    background-color: #3b5998;
}

#facebook-share-button:hover {
    background-color: #2d4373;
}

#twitter-share-button {
    background-color: #1da1f2;
}

#twitter-share-button:hover {
    background-color: #0d95e8;
}

@keyframes slideUp {
    from {
        transform: translateY(0);
        opacity: 1;
    }
    to {
        transform: translateY(-100%);
        opacity: 0;
    }
}

.slide-up {
    animation: slideUp 0.5s ease forwards;  /* Adjust timing as necessary */
}

@keyframes slideInFromLeft {
    from {
        transform: translateX(-100%);
        opacity: 0;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
}

.slide-in-left {
    animation: slideInFromLeft 0.5s ease-out forwards;
}
#quiz-page.sliding-background::after {
        background-image: url('/Bg.svg'); 

    transform: translateX(100%); 
}
#quiz-page::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    z-index: -1; /* Ensure it's behind the content */
    transition: transform 0.5s ease-out, opacity 0.5s ease-out; /* Smooth transition for the transform */
    transform: translateX(0); /* Start from here */
}
.btn-grid button {
font-family: Futura, serif;
font-size: 16px;
color: #333;
width: 220px;
height: 220px;
border-radius: 10px;
display: flex;
flex-direction: column;   
align-items: center;
justify-content: center; 
padding: 10px 20px;
align-items: center;
margin: 5px;
border: none;
background-color: #ffffff;
gap: 20px; 
cursor: pointer;
transition: background-color 0.3s;
}

.btn-grid button:hover {
  color: #3d3d3d;
    border-radius: 10px;
    border: solid 5px #4bf442;
}
.btn-grid button:disabled {
  background-color: #E0E0E0; 
  cursor: not-allowed; /* Change cursor to indicate it's disabled */
}

.btn-grid button.selected {
    color: #3d3d3d;
    border-radius: 10px;
    border: solid 5px #4bf442;
    background-color: #ffffff;
  
}
.answer-icon {
  width: 100px;  /* Adjust size as needed */
  height: 100px; /* Adjust size to maintain aspect ratio */
  vertical-align: middle; /* Aligns the icon with the text vertically */
  margin-right: 10px; /* Space between the icon and the text */
}

.answer-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #FFFFFF; /* Or any color you prefer */
  border: none; /* Removes the border */
  border-radius: 10px; /* Rounded corners */
  padding: 10px;
  margin: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* Optional shadow for depth */
  cursor: pointer;
  transition: background-color 0.3s; /* Smooth transition for hover effect */
}
.answer-button span {
  font-size: 16px; /* Adjust as needed */
  color: #333; /* Text color */
}

</style>
  